import MDBox from "components/MDBox";
import React, { useEffect, useState, createContext, useContext } from "react";
import QRCode from "qrcode.react";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext } from "App";
import MDButton from "components/MDButton";
import TenantManager from "Classes/API/TenantManager";
import UsersApi from "Classes/API/UsersApi";

const Feedback = () => {
  const { translations } = useContext(LanguageContext);
  const token = UsersApi.GetToken();
  const tenantId = TenantManager.getTenant(token);
  const baseURL = window.location.origin;
  const redirectLink = `${baseURL}/Appointments/FeedbackForm/${tenantId}`;

  const handleDownload = () => {
    const canvas = document.getElementById("qrcode-canvas");
    const imageURL = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "qrcode.png";
    link.click();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={6} mb={3}>
        <div className="row">
          <div className="container">
            <div className="card">
              <div className="card-header">{translations.StasticsFeedback}</div>
              <div className="card-body">
                <div className="card-body">
                  <div className="row">
                    <div className="container text-center">
                      {/* Generate QR code with the redirectLink */}
                      <QRCode id="qrcode-canvas" value={redirectLink} />
                      <div className="mt-3 ml-4">
                        <MDButton
                          sx={{
                            backgroundColor: "#3560AD",
                            "&:hover": { backgroundColor: "#4682B4" },
                          }}
                          color="text"
                          onClick={handleDownload}
                        >
                          {translations.StasticsFeedbackDownloadQRCode}
                        </MDButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MDBox>
    </DashboardLayout>
  );
};

export default Feedback;
